"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4623],{

/***/ 94951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
var objectDestructuringEmpty = __webpack_require__(77191);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/auth.service.ts
var auth_service = __webpack_require__(2586);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Newsletter/Newsletter.elements.tsx




var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Newsletterelements__Section",
  componentId: "sc-1bg7qs3-0"
})(["border-radius:", ";border:1px solid ", ";max-width:", ";margin:0 auto;padding:", " ", ";text-align:center;@media (min-width:", "px){padding:", ";}"], (0,polished_esm/* rem */.hO)(16), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, function (prop) {
  return prop.isStaticBanner ? (0,polished_esm/* rem */.hO)(320) : (0,polished_esm/* rem */.hO)(900);
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(8), theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.isStaticBanner ? (0,polished_esm/* rem */.hO)(20) : (0,polished_esm/* rem */.hO)(30);
});
var Description = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Newsletterelements__Description",
  componentId: "sc-1bg7qs3-1"
})(["display:block;font-size:", ";font-weight:", ";padding-bottom:", ";line-height:", ";"], function (prop) {
  return prop.isStaticBanner ? prop.theme.fontSizes.textMedium : prop.theme.fontSizes.h5;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(28));
var InputSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Newsletterelements__InputSection",
  componentId: "sc-1bg7qs3-2"
})(["position:relative;margin-bottom:", ";display:flex;flex-direction:row;height:", ";gap:", ";"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(15));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "Newsletterelements__Input",
  componentId: "sc-1bg7qs3-3"
})(["width:100%;height:", ";padding:", ";border-radius:", ";background:none;color:", ";border:1px solid ", ";padding-right:", ";font-size:", ";&::placeholder{color:", ";opacity:0.4;}&.error{border-color:", ";}@media (min-width:", "px){padding-right:", ";}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(4), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textBase;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.white;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(60));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Newsletterelements__ErrorMessage",
  componentId: "sc-1bg7qs3-4"
})(["margin:0 0 ", " 0;display:block;font-size:", ";color:", ";text-align:left;position:absolute;bottom:", ";"], (0,polished_esm/* rem */.hO)(10), function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.textSmall;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(-25));
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Newsletterelements__SuccessMessage",
  componentId: "sc-1bg7qs3-5"
})(["margin:0 0 ", " 0;display:block;font-size:", ";color:", ";text-align:left;position:absolute;bottom:", ";"], (0,polished_esm/* rem */.hO)(10), function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSizes.textSmall;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(-30));
var Social = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Newsletterelements__Social",
  componentId: "sc-1bg7qs3-6"
})(["text-align:center;"]);
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Newsletterelements__Link",
  componentId: "sc-1bg7qs3-7"
})(["color:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.black;
});
var Newsletter_elements_Icon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Newsletterelements__Icon",
  componentId: "sc-1bg7qs3-8"
})(["background:", ";margin:", ";border-radius:50%;padding:", " ", ";border:2px solid transparent;cursor:pointer;&:hover{border:2px solid ", ";}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.white;
}, function (prop) {
  return prop.isStaticBanner ? "".concat((0,polished_esm/* rem */.hO)(10), " ").concat((0,polished_esm/* rem */.hO)(4)) : (0,polished_esm/* rem */.hO)(10);
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(8), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.black;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Newsletter/Newsletter.tsx













var NewsletterTemplate = function NewsletterTemplate(_ref) {
  var _ref$isStaticBanner = _ref.isStaticBanner,
      isStaticBanner = _ref$isStaticBanner === void 0 ? false : _ref$isStaticBanner,
      _ref$renderOnlyInput = _ref.renderOnlyInput,
      renderOnlyInput = _ref$renderOnlyInput === void 0 ? false : _ref$renderOnlyInput;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var emailInputRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      hasEmailError = _useState[0],
      setHasEmailError = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasSent = _useState2[0],
      setHasSent = _useState2[1];

  var renderInput = function renderInput() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputSection, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
        ref: emailInputRef,
        placeholder: t('homepage.newsletter.placeholder'),
        className: "".concat(hasEmailError ? 'error' : '')
      }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
        children: t('homepage.newsletter.error')
      }), hasSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
        children: t('homepage.newsletter.sent')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        text: t('homepage.newsletter.button'),
        onClick: function onClick() {
          return handleClick();
        }
      })]
    });
  };

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _emailInputRef$curren, _emailInputRef$curren2, _emailInputRef$curren3;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasEmailError(false);
              setHasSent(false);

              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context.next = 5;
                break;
              }

              setHasEmailError(true);
              return _context.abrupt("return");

            case 5:
              _context.next = 7;
              return auth_service/* authApi.addToNewsletter */.i.addToNewsletter(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value);

            case 7:
              setHasSent(true);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return renderOnlyInput ? renderInput() : /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    withPadding: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      isStaticBanner: isStaticBanner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        children: t('homepage.newsletter.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        isStaticBanner: isStaticBanner,
        dangerouslySetInnerHTML: {
          __html: t('homepage.newsletter.description')
        }
      }), renderInput(), /*#__PURE__*/(0,jsx_runtime.jsxs)(Social, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
          target: "_black",
          href: "https://www.facebook.com/FiremniVzdelavaniStudioW",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter_elements_Icon, {
            isStaticBanner: isStaticBanner,
            name: Icon/* Icons.Facebook */.PJ.Facebook
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
          target: "_black",
          href: "https://www.linkedin.com/company/studio-w",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter_elements_Icon, {
            isStaticBanner: isStaticBanner,
            name: Icon/* Icons.Linkedin */.PJ.Linkedin
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
          target: "_black",
          href: "https://www.youtube.com/@studiow2368",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter_elements_Icon, {
            isStaticBanner: isStaticBanner,
            name: Icon/* Icons.Youtube */.PJ.Youtube
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var Newsletter = (NewsletterTemplate);
;// CONCATENATED MODULE: ./src/components/Footer/Footer.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__Background",
  componentId: "sc-1olqlmj-0"
})(["background:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__Title",
  componentId: "sc-1olqlmj-1"
})(["text-align:center;padding:", " 0 ", " 0;line-height:", ";"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(24));
var Portals = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__Portals",
  componentId: "sc-1olqlmj-2"
})(["display:flex;margin:", " 0;flex-wrap:wrap;@media (min-width:", "px){flex-wrap:unset;justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
var Portal = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Footerelements__Portal",
  componentId: "sc-1olqlmj-3"
})(["flex:50%;text-align:center;svg{width:", ";}"], (0,polished_esm/* rem */.hO)(180));
var Footer_elements_Social = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__Social",
  componentId: "sc-1olqlmj-4"
})(["margin-top:", ";@media (min-width:", "px){position:absolute;right:0;top:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(25));
var Navigation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__Navigation",
  componentId: "sc-1olqlmj-5"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;font-size:", ";border-bottom:2px solid ", ";padding-bottom:", ";margin:0 5%;@media (min-width:", "px){margin:0;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textBase;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(45), theme/* breakpoints.lg */.A.lg);
var NavigationSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__NavigationSection",
  componentId: "sc-1olqlmj-6"
})(["display:flex;flex:100%;flex-direction:column;margin-bottom:", ";align-items:center;@media (min-width:", "px){flex:30%;align-items:unset;}@media (min-width:", "px){flex:unset;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.xs */.A.xs, theme/* breakpoints.lg */.A.lg);
var NavigationTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Footerelements__NavigationTitle",
  componentId: "sc-1olqlmj-7"
})(["font-weight:", ";padding-bottom:", ";text-transform:uppercase;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20));
var NavigationItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__NavigationItem",
  componentId: "sc-1olqlmj-8"
})(["cursor:pointer;padding-bottom:", ";font-size:", ";display:flex;align-items:center;color:", ";text-decoration:unset;opacity:0.7;&:hover{opacity:1;}"], (0,polished_esm/* rem */.hO)(20), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.textSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
});
var NavigationLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Footerelements__NavigationLink",
  componentId: "sc-1olqlmj-9"
})(["color:", ";margin-left:", ";text-decoration:unset;&:hover{opacity:1;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
}, function (props) {
  return props.$withoutMargin ? 0 : (0,polished_esm/* rem */.hO)(10);
});
var Settings = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__Settings",
  componentId: "sc-1olqlmj-10"
})(["display:flex;align-items:center;font-size:", ";flex-direction:column;padding-bottom:", ";position:relative;@media (min-width:", "px){flex-direction:row;align-items:flex-end;gap:", ";padding-bottom:", ";}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
var SettingLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Footerelements__SettingLink",
  componentId: "sc-1olqlmj-11"
})(["cursor:pointer;padding-bottom:", ";color:", ";text-decoration:unset;opacity:0.7;&:hover{opacity:1;}@media (min-width:", "px){padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(10), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.white;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30));
var NewsletterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Footerelements__NewsletterSection",
  componentId: "sc-1olqlmj-12"
})(["background:", ";border-radius:", ";padding:", " ", ";@media (min-width:", "px){width:40%;min-width:", ";}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(350));
var NewsletterTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Footerelements__NewsletterTitle",
  componentId: "sc-1olqlmj-13"
})(["font-size:", ";font-weight:", ";color:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSizes.h6;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontWeights.textBold;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.darkMedium;
});
var NewsletterDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Footerelements__NewsletterDescription",
  componentId: "sc-1olqlmj-14"
})(["line-height:", ";padding-bottom:", ";color:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.darkMedium;
});
var NewsletterLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Footerelements__NewsletterLabel",
  componentId: "sc-1olqlmj-15"
})(["line-height:", ";color:", ";a{color:", ";cursor:pointer;}"], (0,polished_esm/* rem */.hO)(20), function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.darkMedium;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.primary;
});
;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var COMPANY_NAVIGATION_ITEM_KEYS = [{
  title: 'footer.company.about',
  path: 'https://pp.sk/onas'
}, {
  title: 'footer.company.centre',
  path: 'https://pp.sk/onas#sect05'
}, {
  title: 'footer.company.carrier',
  path: 'https://pp.sk/onas#sect03'
}, {
  title: 'footer.company.support',
  path: 'https://pp.sk/podporujeme'
}, {
  title: 'footer.company.contact',
  path: 'https://pp.sk/kontakt'
}];
var LEARNING_NAVIGATION_ITEM_KEYS = [{
  title: 'footer.learning.about',
  path: constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US
}, {
  title: 'footer.learning.subscription',
  path: constants/* ROUTES.SUBSCRIPTION */.Z6.SUBSCRIPTION
}, {
  title: 'footer.learning.training',
  path: constants/* ROUTES.COMPANY_COURSES */.Z6.COMPANY_COURSES
}, {
  title: 'footer.learning.reference',
  path: "".concat(constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US, "#referencie")
}, {
  title: 'footer.learning.faq',
  path: "".concat(constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US, "#faqs")
}, {
  title: 'footer.learning.contact',
  path: constants/* ROUTES.CONTACT */.Z6.CONTACT
}, {
  title: 'footer.learning.blog',
  path: constants/* ROUTES.BLOG */.Z6.BLOG
}];
var QUALITY_CRITERIA_ITEM_KEYS = [{
  title: 'footer.quality_criteria.educational_code_ethics',
  path: constants/* ROUTES.EDUCATIONAL_CODE_ETHICS */.Z6.EDUCATIONAL_CODE_ETHICS
}, {
  title: 'footer.quality_criteria.education_quality_management_system',
  path: constants/* ROUTES.EDUCATION_QUALITY_MANAGEMENT_SYSTEM */.Z6.EDUCATION_QUALITY_MANAGEMENT_SYSTEM
}, {
  title: 'footer.quality_criteria.teacher_team_development_strategy',
  path: constants/* ROUTES.TEACHER_TEAM_DEVELOPMENT_STRATEGY */.Z6.TEACHER_TEAM_DEVELOPMENT_STRATEGY
}];

var FooterTemplate = function FooterTemplate(_ref) {
  (0,objectDestructuringEmpty/* default */.Z)(_ref);

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var handleRedirect = function handleRedirect(path) {
    return router.push(path, undefined, {
      scroll: true
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Background, {
    id: "footer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: t('footer.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Portals, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Portal, {
          href: "https://www.danovecentrum.sk",
          target: "_black",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: Icon/* Icons.Danove */.PJ.Danove,
            width: 180,
            height: 100
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Portal, {
          href: "https://www.mzdovecentrum.sk",
          target: "_black",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: Icon/* Icons.Mzdove */.PJ.Mzdove,
            width: 180,
            height: 100
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Portal, {
          href: "https://www.profivzdelavanie.sk",
          target: "_black",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: Icon/* Icons.Profi */.PJ.Profi,
            width: 180,
            height: 100
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Portal, {
          href: "https://www.vssr.sk",
          target: "_black",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: Icon/* Icons.Sprava */.PJ.Sprava,
            width: 180,
            height: 100
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Portal, {
          href: "https://www.bezpecnostvpraxi.sk",
          target: "_black",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: Icon/* Icons.Bezpecnost */.PJ.Bezpecnost,
            width: 180,
            height: 100
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Navigation, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationTitle, {
            children: t('footer.company.title')
          }), COMPANY_NAVIGATION_ITEM_KEYS.map(function (item, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItem, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationLink, {
                $withoutMargin: true,
                href: item.path,
                target: "_blank",
                children: t(item.title)
              })
            }, key);
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationTitle, {
            children: t('footer.learning.title')
          }), LEARNING_NAVIGATION_ITEM_KEYS.map(function (item, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItem, {
              onClick: function onClick() {
                return handleRedirect(item.path);
              },
              children: t(item.title)
            }, key);
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationTitle, {
            children: t('footer.quality_criteria.title')
          }), QUALITY_CRITERIA_ITEM_KEYS.map(function (item, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItem, {
              onClick: function onClick() {
                return handleRedirect(item.path);
              },
              children: t(item.title)
            }, key);
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NewsletterSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NewsletterTitle, {
            children: "Nech\xE1te n\xE1m email?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NewsletterDescription, {
            children: "Pravidelne dostanete inform\xE1cie o legislat\xEDve, \u0161koleniach, konferenci\xE1ch a v\xFDhodn\xFDch ponuk\xE1ch."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter, {
            renderOnlyInput: true
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NewsletterLabel, {
            children: ["Odoslan\xEDm formul\xE1ra s\xFAhlas\xEDte s doru\u010Dovan\xEDm", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              onClick: function onClick() {
                return router.push("".concat(constants/* ROUTES.GDPR */.Z6.GDPR, "#marketing"));
              },
              children: "marketingovej komunik\xE1cie."
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Settings, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
          name: Icon/* Icons.Poradca */.PJ.Poradca,
          width: 180,
          height: 100
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SettingLink, {
          onClick: function onClick() {
            return handleRedirect(constants/* ROUTES.GDPR */.Z6.GDPR);
          },
          children: t('footer.privacy')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SettingLink, {
          onClick: function onClick() {
            return router.push({
              pathname: router.pathname,
              query: _objectSpread(_objectSpread({}, router.query), {}, {
                updateCookies: true
              })
            });
          },
          children: t('footer.cookies')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SettingLink, {
          onClick: function onClick() {
            return handleRedirect(constants/* ROUTES.CONDITIONS */.Z6.CONDITIONS);
          },
          children: t('footer.conditions')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SettingLink, {
          onClick: function onClick() {
            return handleRedirect(constants/* ROUTES.ACCESSIBILITY */.Z6.ACCESSIBILITY);
          },
          children: t('footer.accessibility')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SettingLink, {
          onClick: function onClick() {
            return handleRedirect(constants/* ROUTES.WITHDRAWAL */.Z6.WITHDRAWAL);
          },
          children: t('footer.withdrawal')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Footer_elements_Social, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationLink, {
            href: "https://www.instagram.com/poradcapodnikatela",
            target: "_black",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: Icon/* Icons.Instagram */.PJ.Instagram,
              width: 25,
              height: 25
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationLink, {
            href: "https://sk.linkedin.com/company/poradca-podnikatela-spol-s-r-o-",
            target: "_black",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: Icon/* Icons.Linkedin */.PJ.Linkedin,
              width: 25,
              height: 25
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationLink, {
            href: "https://sk-sk.facebook.com/PoradcaPodnikatela",
            target: "_black",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: Icon/* Icons.Facebook */.PJ.Facebook,
              width: 25,
              height: 25
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationLink, {
            href: "https://www.youtube.com/user/PoradcaPodnikatela",
            target: "_black",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.ZP, {
              name: Icon/* Icons.Youtube */.PJ.Youtube,
              width: 25,
              height: 25
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var Footer = (FooterTemplate);

/***/ }),

/***/ 50866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Header/Header.elements.tsx







var Desktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__Desktop",
  componentId: "sc-14qvgb8-0"
})(["padding:0 ", " 0 ", ";height:", ";position:fixed;z-index:999;width:100vw;top:0;background:", ";border-bottom:1px solid ", ";display:flex;align-items:center;@media (min-width:", "px){height:", ";padding:", ";align-items:unset;justify-content:center;}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(20));
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__Row",
  componentId: "sc-14qvgb8-1"
})(["display:", ";flex-direction:row;justify-content:space-between;@media (min-width:", "px){display:flex;margin-top:", ";}"], function (props) {
  return props.$hideOnTablet ? 'none' : 'flex';
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(-15));
var Group = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__Group",
  componentId: "sc-14qvgb8-2"
})(["display:flex;flex-direction:row;align-items:center;gap:", ";@media (min-width:", "px){gap:", ";}"], (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(20));
var MaxWidthWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__MaxWidthWrapper",
  componentId: "sc-14qvgb8-3"
})(["display:flex;flex-direction:column;justify-content:space-between;width:100%;@media (min-width:", "px){max-width:", ";}"], theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(1180));
var ContactLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Headerelements__ContactLink",
  componentId: "sc-14qvgb8-4"
})(["display:flex;flex-direction:row;align-items:center;font-family:", ";color:", ";font-size:", ";svg{width:", ";height:", ";margin-bottom:-", ";margin-right:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(18), (0,polished_esm/* rem */.hO)(18), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5));
var ContactLinkLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__ContactLinkLabel",
  componentId: "sc-14qvgb8-5"
})(["display:none;@media (min-width:", "px){display:block;}"], theme/* breakpoints.lg */.A.lg);
var SearchSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__SearchSection",
  componentId: "sc-14qvgb8-6"
})(["background:", ";position:absolute;width:100%;height:100%;left:0;top:0;padding:", " ", " 0 ", ";z-index:9999;svg{position:absolute;}button{position:absolute;right:", ";top:", ";}@media (min-width:", "px){position:relative;padding:0;width:auto;height:auto;button{right:", ";top:", ";}}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(17), (0,polished_esm/* rem */.hO)(12), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(2));
var SearchCloseButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__SearchCloseButton",
  componentId: "sc-14qvgb8-7"
})(["font-size:", ";text-decoration:underline;color:", ";cursor:pointer;position:absolute;bottom:", ";padding:0;background:none;border:none;left:40%;@media (min-width:", "px){display:none;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.textSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(4), theme/* breakpoints.sm */.A.sm);
var SearchInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "Headerelements__SearchInput",
  componentId: "sc-14qvgb8-8"
})(["height:", ";border-radius:", ";padding:", " ", " ", " ", ";width:100%;font-size:", ";border:1px solid ", ";background:url(", ") no-repeat;background-position:left ", " bottom 50%;background-size:", ";@media (min-width:", "px){width:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(6), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(14), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.border;
}, (0,url_utils/* publicAssets */.VK)('/search.svg'), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(320), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(380));
var SearchHidden = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "Headerelements__SearchHidden",
  componentId: "sc-14qvgb8-9"
})(["display:block;width:0;height:0;position:absolute;z-index:-1;top:23px;right:50px;"]);
var Account = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__Account",
  componentId: "sc-14qvgb8-10"
})(["position:relative;"]);
var Notifications = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__Notifications",
  componentId: "sc-14qvgb8-11"
})(["position:relative;"]);
var NavigationNotifications = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationNotifications",
  componentId: "sc-14qvgb8-12"
})(["background:", ";position:absolute;width:", ";right:", ";border-radius:", ";display:flex;flex-direction:column;align-items:flex-start;top:", ";z-index:99999;border:1px solid ", ";max-height:", ";overflow-y:scroll;@media (min-width:", "px){width:", ";right:", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(275), (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(40), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(400), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(340), (0,polished_esm/* rem */.hO)(10));
var NavigationEmptyMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationEmptyMessage",
  componentId: "sc-14qvgb8-13"
})(["display:flex;width:100%;align-items:center;padding:", " ", ";font-family:", ";text-align:center;justify-content:center;line-height:", ";color:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(15), function (_ref12) {
  var theme = _ref12.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(25), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.grey;
});
var NavigationNotification = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationNotification",
  componentId: "sc-14qvgb8-14"
})(["display:flex;width:100%;align-items:center;gap:", ";padding:", " ", " ", " ", ";position:relative;cursor:pointer;&:not(:last-child){border-bottom:1px solid ", ";}&:hover,&:focus-visible{background:", ";}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.border;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.darkLight;
});
var NavigationNotificationIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Headerelements__NavigationNotificationIcon",
  componentId: "sc-14qvgb8-15"
})(["svg{width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30));
var NavigationNotificationDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationNotificationDetail",
  componentId: "sc-14qvgb8-16"
})(["display:flex;flex-direction:column;gap:", ";"], (0,polished_esm/* rem */.hO)(5));
var NavigationNotificationDetailTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__NavigationNotificationDetailTitle",
  componentId: "sc-14qvgb8-17"
})(["font-weight:", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontWeights.textBold;
});
var NavigationNotificationDetailDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Headerelements__NavigationNotificationDetailDescription",
  componentId: "sc-14qvgb8-18"
})(["margin:", " 0 ", " 0;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(2), (0,polished_esm/* rem */.hO)(4), function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontSizes.textBase;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.dark;
});
var NavigationNotificationCloseButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__NavigationNotificationCloseButton",
  componentId: "sc-14qvgb8-19"
})(["font-size:", ";color:", ";cursor:pointer;opacity:0.8;position:absolute;top:", ";right:", ";"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSizes.textBase;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(14));
var NavigationNotificationDetailDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__NavigationNotificationDetailDate",
  componentId: "sc-14qvgb8-20"
})(["font-size:", ";color:", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontSizes.textBase;
}, function (props) {
  return props.isPrimary ? props.theme.colors.primary : props.theme.colors.grey;
});
var NavigationNotificationDetailDateUnread = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationNotificationDetailDateUnread",
  componentId: "sc-14qvgb8-21"
})(["display:inline-block;background:", ";width:", ";height:", ";border-radius:50%;margin-left:", ";"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10));
var NavigationNotificationShowMoreLink = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Headerelements__NavigationNotificationShowMoreLink",
  componentId: "sc-14qvgb8-22"
})(["background:none;border:none;margin:0 auto;padding:", " 0;font-size:", ";cursor:pointer;color:", ";text-decoration:underline;"], (0,polished_esm/* rem */.hO)(10), function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontSizes.textBase;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.primary;
});
var NavigationAccount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationAccount",
  componentId: "sc-14qvgb8-23"
})(["background:", ";position:absolute;width:", ";right:", ";border-radius:", ";display:flex;flex-direction:column;align-items:flex-start;z-index:99999;border:1px solid ", ";"], function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(300), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(4), function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.border;
});
var NavigationAccountHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationAccountHeader",
  componentId: "sc-14qvgb8-24"
})(["display:flex;flex-direction:column;width:100%;margin-bottom:", ";border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(10), function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.border;
});
var NavigationAccountLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__NavigationAccountLabel",
  componentId: "sc-14qvgb8-25"
})(["padding:0 0 ", " ", ";font-weight:", ";font-size:", ";margin-top:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(25), function (_ref28) {
  var theme = _ref28.theme;
  return theme.fontWeights.textBold;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(15));
var NavigationAccountMail = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__NavigationAccountMail",
  componentId: "sc-14qvgb8-26"
})(["font-size:", ";padding:0 0 ", " ", ";"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(25));
var NavigationAccountCloseButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__NavigationAccountCloseButton",
  componentId: "sc-14qvgb8-27"
})(["text-align:right;font-weight:", ";padding:", " ", " 0 0;cursor:pointer;"], function (_ref31) {
  var theme = _ref31.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10));
var NavigationAccountLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Headerelements__NavigationAccountLink",
  componentId: "sc-14qvgb8-28"
})(["margin-left:", ";background:none;padding:", " 0;cursor:pointer;border:none;text-decoration:none;&:hover,&:focus-visible{color:", ";}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(4), function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.primary;
});
var Logo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Headerelements__Logo",
  componentId: "sc-14qvgb8-29"
})(["width:", ";height:", ";cursor:pointer;margin-left:", ";@media (min-width:", "px){width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(145), (0,polished_esm/* rem */.hO)(65), (0,polished_esm/* rem */.hO)(-10), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(160), (0,polished_esm/* rem */.hO)(70));
var NavigationDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationDesktop",
  componentId: "sc-14qvgb8-30"
})(["font-weight:", ";display:none;color:", ";font-family:", ";@media (min-width:", "px){display:block;font-size:", ";white-space:nowrap;}@media (min-width:", "px){display:block;font-size:", ";}"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.fontWeights.textBold;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.colors.black;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.fonts.fontSecondary;
}, theme/* breakpoints.sm */.A.sm, function (_ref36) {
  var theme = _ref36.theme;
  return theme.fontSizes.textBase;
}, theme/* breakpoints.sm */.A.sm, function (_ref37) {
  var theme = _ref37.theme;
  return theme.fontSizes.textMedium;
});
var NavigationMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationMobile",
  componentId: "sc-14qvgb8-31"
})(["display:flex;flex-direction:column;font-family:", ";color:", ";position:absolute;left:0;top:0;width:", ";height:100vh;background:", ";padding:", ";overflow-y:scroll;@media (min-width:", "px){display:none;}&.isOpen{transform:translateX(0);opacity:1;transition:transform 0.5s,opacity 1s;}&.isClose{transform:translateX(-300px);opacity:0;transition:transform 1s,opacity 1s;}"], function (_ref38) {
  var theme = _ref38.theme;
  return theme.fonts.fontSecondary;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(300), function (_ref40) {
  var theme = _ref40.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.lg */.A.lg);
var NavigationItem = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "Headerelements__NavigationItem",
  componentId: "sc-14qvgb8-32"
})(["margin:", ";cursor:pointer;color:", ";text-decoration:none;&:hover,&:focus-visible{color:", ";}svg{width:", ";height:", ";margin-bottom:-", ";margin-right:", ";}@media (min-width:", "px){margin:", " ", " ", " 0;&:hover,&:focus-visible{border-bottom:1px solid ", ";padding-bottom:", ";}&.isActive{border-bottom:1px solid ", ";padding-bottom:", ";}}&.isActive{color:", ";}"], function (props) {
  return props.$marginTop ? "".concat((0,polished_esm/* rem */.hO)(props.$marginTop), " 0 ").concat((0,polished_esm/* rem */.hO)(15), " 0") : "".concat((0,polished_esm/* rem */.hO)(15), " 0");
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.colors.black;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(8), function (_ref43) {
  var theme = _ref43.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(20), function (_ref44) {
  var theme = _ref44.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(20), function (_ref45) {
  var theme = _ref45.theme;
  return theme.colors.primary;
});
var NavigationItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NavigationItemMobile",
  componentId: "sc-14qvgb8-33"
})(["margin:", ";cursor:pointer;color:", ";text-decoration:none;&:hover,&:focus-visible{color:", ";}svg{width:", ";height:", ";margin-bottom:-", ";margin-right:", ";}@media (min-width:", "px){margin:", " ", " ", " 0;&:hover,&:focus-visible{border-bottom:1px solid ", ";padding-bottom:", ";}&.isActive{border-bottom:1px solid ", ";padding-bottom:", ";}}&.isActive{color:", ";}"], function (props) {
  return props.marginTop ? "".concat((0,polished_esm/* rem */.hO)(props.marginTop), " 0 ").concat((0,polished_esm/* rem */.hO)(15), " 0") : "".concat((0,polished_esm/* rem */.hO)(15), " 0");
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.colors.black;
}, function (_ref47) {
  var theme = _ref47.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(8), function (_ref48) {
  var theme = _ref48.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(20), function (_ref49) {
  var theme = _ref49.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(20), function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.primary;
});
var NavigationCloseButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__NavigationCloseButton",
  componentId: "sc-14qvgb8-34"
})(["position:absolute;top:", ";right:", ";font-size:", ";cursor:pointer;color:", ";"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), function (_ref51) {
  var theme = _ref51.theme;
  return theme.fontSizes.h5;
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.colors.black;
});
var MySWButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__MySWButton",
  componentId: "sc-14qvgb8-35"
})(["display:none;@media (min-width:", "px){display:block;}"], theme/* breakpoints.sm */.A.sm);
var LoginButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__LoginButton",
  componentId: "sc-14qvgb8-36"
})(["display:none;@media (min-width:", "px){display:block;}"], theme/* breakpoints.sm */.A.sm);
var MenuIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Headerelements__MenuIcon",
  componentId: "sc-14qvgb8-37"
})(["display:block;cursor:pointer;order:5;svg{width:", ";height:", ";}@media (min-width:", "px){display:none;order:unset;svg{width:", ";height:", ";}}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30));
var SearchIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Headerelements__SearchIcon",
  componentId: "sc-14qvgb8-38"
})(["display:block;cursor:pointer;svg{width:", ";height:", ";}@media (min-width:", "px){display:none;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm);
var NotificationIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Headerelements__NotificationIcon",
  componentId: "sc-14qvgb8-39"
})(["cursor:pointer;svg{width:", ";height:", ";margin-top:", ";}@media (min-width:", "px){svg{width:", ";height:", ";}}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(-2), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30));
var NotificationUnread = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__NotificationUnread",
  componentId: "sc-14qvgb8-40"
})(["background:", ";width:", ";height:", ";border-radius:50%;position:absolute;top:0;right:0;"], function (_ref53) {
  var theme = _ref53.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10));
var AccountIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Headerelements__AccountIcon",
  componentId: "sc-14qvgb8-41"
})(["cursor:pointer;svg{width:", ";height:", ";path{fill:", ";}}@media (min-width:", "px){svg{width:", ";height:", ";}}"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), function (_ref54) {
  var theme = _ref54.theme;
  return theme.colors.primary;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(40));
var CardSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Headerelements__CardSection",
  componentId: "sc-14qvgb8-42"
})(["position:relative;cursor:pointer;display:flex;align-items:center;"]);
var CardCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Headerelements__CardCount",
  componentId: "sc-14qvgb8-43"
})(["position:absolute;background:", ";color:", ";right:-", ";top:-", ";border-radius:50%;width:", ";height:", ";display:flex;justify-content:center;align-items:center;font-size:", ";"], function (_ref55) {
  var theme = _ref55.theme;
  return theme.colors.primary;
}, function (_ref56) {
  var theme = _ref56.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref57) {
  var theme = _ref57.theme;
  return theme.fontSizes.textSmall;
});
var CardIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Headerelements__CardIcon",
  componentId: "sc-14qvgb8-44"
})(["svg{width:", ";height:", ";}@media (min-width:", "px){svg{width:", ";height:", ";}}"], (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(25));
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/components/Modal/Login/LoginModal.tsx + 1 modules
var LoginModal = __webpack_require__(2298);
// EXTERNAL MODULE: ./src/hooks/useCart.tsx + 1 modules
var useCart = __webpack_require__(44722);
;// CONCATENATED MODULE: ./src/hooks/useOnClickOutside.tsx


var useOnClickOutside = function useOnClickOutside(ref, handler, nodesToIgnore) {
  (0,react.useEffect)(function () {
    var listener = function listener(event) {
      var isTargetHTMLElement = function isTargetHTMLElement(target) {
        return target instanceof HTMLElement;
      };

      if (!ref.current || !isTargetHTMLElement(event.target) || ref.current.contains(event.target)) {
        return;
      }

      if (nodesToIgnore) {
        var shouldIgnoreClick = nodesToIgnore.some(function (node) {
          if (!isTargetHTMLElement(event.target)) {
            return false;
          }

          return node.current.contains(event.target);
        });

        if (shouldIgnoreClick) {
          return;
        }
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, nodesToIgnore]);
};

/* harmony default export */ var hooks_useOnClickOutside = (useOnClickOutside);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/utils/time.utils.ts
var time_utils = __webpack_require__(775);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/interfaces/Calendar.ts
var Calendar = __webpack_require__(17923);
// EXTERNAL MODULE: ./src/services/auth.service.ts
var auth_service = __webpack_require__(2586);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
// EXTERNAL MODULE: ./src/store/ui.ts
var ui = __webpack_require__(18770);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx + 9 modules
var Modal = __webpack_require__(82059);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Header/Header.tsx



























var CARD_BUTTON_ID = 'card-button';
var CARD_VIEWER_ID = 'card-viewer';
var HEADER_ID = 'header';
var NAVIGATION_ITEMS_KEYS = [{
  title: 'header.courses',
  path: constants/* ROUTES.TRAININGS */.Z6.TRAININGS
}, {
  title: 'header.conference',
  path: constants/* ROUTES.CONFERENCES */.Z6.CONFERENCES
}, {
  title: 'header.subscription',
  path: constants/* ROUTES.SUBSCRIPTION */.Z6.SUBSCRIPTION
}, {
  title: 'header.educationalPrograms',
  path: constants/* ROUTES.EDUCATIONAL_PROGRAMS */.Z6.EDUCATIONAL_PROGRAMS
}, {
  title: 'header.companyCourses',
  path: constants/* ROUTES.COMPANY_COURSES */.Z6.COMPANY_COURSES
}, {
  title: 'header.about',
  path: constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US
}, {
  title: 'header.contact',
  path: constants/* ROUTES.CONTACT */.Z6.CONTACT
}];

var HeaderTemplate = function HeaderTemplate() {
  var _router$pathname, _router$pathname2, _router$pathname3, _router$query, _notifications$filter;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var searchInputRef = (0,react.useRef)();
  var router = (0,next_router.useRouter)();

  var _useCart = (0,useCart/* default */.ZP)(),
      getItemsFromCart = _useCart.getItemsFromCart;

  var dispatch = (0,es/* useDispatch */.I0)();
  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });
  var countOfProductsInCart = (0,es/* useSelector */.v9)(function (state) {
    return state.checkout.countOfProductsInCart;
  });

  var _useState = (0,react.useState)(false),
      isLoggedIn = _useState[0],
      setIsLoggedIn = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isMobileOpen = _useState2[0],
      setIsMobileOpen = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isAccountOpen = _useState3[0],
      setIsAccountOpen = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isSearchOpen = _useState4[0],
      setIsSearchOpen = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isNotificationOpen = _useState5[0],
      setIsNotificationOpen = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      user = _useState6[0],
      setUser = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      notifications = _useState7[0],
      setNotifications = _useState7[1];

  var _useState8 = (0,react.useState)(0),
      notificationsTotalCount = _useState8[0],
      setNotificationsTotalCount = _useState8[1];

  var mobileRef = (0,react.useRef)();
  hooks_useOnClickOutside(mobileRef, function () {
    if (isMobileOpen) {
      toggleDisabledBackground();
      setIsMobileOpen(false);
    }

    if (isAccountOpen) {
      setIsAccountOpen(false);
    }

    if (isNotificationOpen) {
      setIsNotificationOpen(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    var _document;

    window.addEventListener('scroll', function () {
      var element = document.getElementById(HEADER_ID);

      if (element) {
        if (window.scrollY > 0) {
          element.style.boxShadow = "0 4px 4px ".concat(theme/* theme.colors.greyMedium */.r.colors.greyMedium);
        } else {
          element.style.boxShadow = 'unset';
        }
      }
    });
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && isLoggedIn && !js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY */.Wx)) {
        router.reload();
      }
    });
  }, [isLoggedIn]);
  (0,react.useEffect)(function () {
    var cardButton = document.getElementById(CARD_BUTTON_ID);
    var cardViewer = document.getElementById(CARD_VIEWER_ID);

    if (cardButton && cardViewer && window.innerWidth > theme/* breakpoints.sm */.A.sm) {
      cardButton.addEventListener('mouseover', function () {
        cardViewer.style.display = 'block';
      });
      cardButton.addEventListener('mouseout', function () {
        cardViewer.style.display = 'none';
      });
      cardViewer.addEventListener('mouseover', function () {
        cardViewer.style.display = 'block';
      });
      cardViewer.addEventListener('mouseout', function () {
        cardViewer.style.display = 'none';
      });
    }

    if (window.innerWidth > theme/* breakpoints.sm */.A.sm) {
      setIsSearchOpen(true);
    }
  }, []);
  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);
  (0,react.useEffect)(function () {
    if (isLoggedIn) {
      auth_service/* authApi.getUser */.i.getUser().then(function (_ref) {
        var data = _ref.data;
        setUser(data);
        calendar_service/* calendarApi.getMyNotifications */.w.getMyNotifications().then(function (_ref2) {
          var data = _ref2.data;
          setNotifications(data === null || data === void 0 ? void 0 : data.results);
          setNotificationsTotalCount(data === null || data === void 0 ? void 0 : data.total_count);
        })["catch"]();
      })["catch"](function () {
        return logout();
      });
    } else {
      setUser(null);
    }
  }, [isLoggedIn]);
  (0,react.useEffect)(function () {
    if (isLoggedIn) {
      setInterval( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                calendar_service/* calendarApi.getMyNotifications */.w.getMyNotifications().then(function (_ref4) {
                  var data = _ref4.data;
                  setNotifications(data === null || data === void 0 ? void 0 : data.results);
                  setNotificationsTotalCount(data === null || data === void 0 ? void 0 : data.totalCount);
                })["catch"]();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })), 10 * 60 * 1000);
    }
  }, [isLoggedIn]);
  (0,react.useEffect)(function () {
    if (!countOfProductsInCart && !router.pathname.includes(constants/* ROUTES.CART */.Z6.CART) && !router.pathname.includes(constants/* ROUTES.SHOP_PARTICIPANTS */.Z6.SHOP_PARTICIPANTS) && !router.pathname.includes(constants/* ROUTES.SHOP_BILLING */.Z6.SHOP_BILLING) && !router.pathname.includes(constants/* ROUTES.SHOP_PAYMENT */.Z6.SHOP_PAYMENT) && !router.pathname.includes(constants/* ROUTES.SHOP_SUMMARY */.Z6.SHOP_SUMMARY) && !router.pathname.includes(constants/* ROUTES.SHOP_CONFIRMATION */.Z6.SHOP_CONFIRMATION)) {
      getItemsFromCart(true);
    }
  }, []);

  var getNotificationIconByCategory = function getNotificationIconByCategory(category) {
    if (category === Calendar/* NotificationCategory.notice */.mN.notice) return Icon/* Icons.Notice */.PJ.Notice;
    if (category === Calendar/* NotificationCategory.futureCourse */.mN.futureCourse || category === Calendar/* NotificationCategory.futureCourseReminder */.mN.futureCourseReminder) return Icon/* Icons.FutureCourse */.PJ.FutureCourse;
    if (category === Calendar/* NotificationCategory.recording */.mN.recording || category === Calendar/* NotificationCategory.recordingReminder */.mN.recordingReminder) return Icon/* Icons.Record */.PJ.Record;
    if (category === Calendar/* NotificationCategory.recommendation */.mN.recommendation) return Icon/* Icons.Recommendation */.PJ.Recommendation;
  };

  var logout = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(js_cookie/* default.get */.Z.get(constants/* REFRESH_TOKEN_KEY */.w4) && js_cookie/* default.get */.Z.get(constants/* REFRESH_TOKEN_KEY */.w4) !== 'undefined')) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return auth_service/* authApi.logout */.i.logout();

            case 3:
              js_cookie/* default.remove */.Z.remove(constants/* ACCESS_TOKEN_KEY */.Wx);
              js_cookie/* default.remove */.Z.remove(constants/* REFRESH_TOKEN_KEY */.w4);
              dispatch((0,ui/* setIsLoggedIn */.nf)(false));
              router.push({
                pathname: constants/* ROUTES.HOME */.Z6.HOME
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function logout() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handlePreviousNotifications = function handlePreviousNotifications() {
    calendar_service/* calendarApi.getMyNotifications */.w.getMyNotifications((notifications === null || notifications === void 0 ? void 0 : notifications.length) + 10).then(function (_ref6) {
      var data = _ref6.data;
      setNotifications(data === null || data === void 0 ? void 0 : data.results);
      setNotificationsTotalCount(data === null || data === void 0 ? void 0 : data.total_count);
    })["catch"]();
  };

  var handleSearch = function handleSearch() {
    var _searchInputRef$curre;

    if ((searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.value) !== '') {
      router.push({
        pathname: constants/* ROUTES.SEARCH */.Z6.SEARCH,
        query: {
          search: searchInputRef.current.value
        }
      });
    }
  };

  var handleRedirect = function handleRedirect(path) {
    return router.push(path);
  };

  var handleLoginOrLogout = function handleLoginOrLogout() {
    if (isLoggedIn) return logout();

    if (isMobileOpen) {
      toggleDisabledBackground();
      setIsMobileOpen(false);
    }

    dispatch((0,ui/* openModalType */.$X)({
      type: Modal/* ModalTypes.LOGIN */.Q.LOGIN
    }));
  };

  var toggleDisabledBackground = function toggleDisabledBackground(withHeader) {
    var divs = document.querySelectorAll("body > div > div:not(#".concat(constants/* GLOBAL_SEARCH_COMPONENT_ID */.g, "):not(#").concat(withHeader ? null : constants/* HEADER_COMPONENT_ID */.L7)); // @ts-ignore

    (0,toConsumableArray/* default */.Z)(divs).map(function (div) {
      return div.style.opacity = isMobileOpen || isSearchOpen ? 1 : 0.2;
    });
  };

  var handleMenuItem = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(url) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (isMobileOpen) {
                toggleDisabledBackground();
                setIsMobileOpen(false);
              }

              return _context3.abrupt("return", router.push(url));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleMenuItem(_x) {
      return _ref7.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Desktop, {
      id: HEADER_ID,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MaxWidthWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {
            onClick: function onClick() {
              return handleRedirect(constants/* ROUTES.HOME */.Z6.HOME);
            },
            src: (0,url_utils/* publicAssets */.VK)('/logo.webp')
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Group, {
            children: [isSearchOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)(SearchSection, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SearchInput, {
                onKeyUp: function onKeyUp(e) {
                  return e.keyCode === LoginModal/* ENTER_KEY_CODE */.zy && handleSearch();
                },
                defaultValue: !(router !== null && router !== void 0 && (_router$pathname = router.pathname) !== null && _router$pathname !== void 0 && _router$pathname.includes(constants/* ROUTES.MY_PV */.Z6.MY_PV)) && !(router !== null && router !== void 0 && (_router$pathname2 = router.pathname) !== null && _router$pathname2 !== void 0 && _router$pathname2.includes(constants/* ROUTES.TRAININGS */.Z6.TRAININGS)) && !(router !== null && router !== void 0 && (_router$pathname3 = router.pathname) !== null && _router$pathname3 !== void 0 && _router$pathname3.includes(constants/* ROUTES.CONFERENCES */.Z6.CONFERENCES)) ? (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.search : '',
                placeholder: t('header.search'),
                ref: searchInputRef,
                type: "search",
                name: "global-search",
                autoComplete: "one-time-code"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchHidden, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: handleSearch,
                text: t('header.search.searchButton'),
                whiteType: true,
                size: Button/* ButtonSizes.SMALL */.P.SMALL
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchCloseButton, {
                onClick: function onClick() {
                  return setIsSearchOpen(false);
                },
                children: t('header.search.closeButton')
              })]
            }), isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsx)(MySWButton, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                text: t('header.mySW'),
                onClick: function onClick() {
                  return router.push({
                    pathname: constants/* ROUTES.MY_PV_COURSES */.Z6.MY_PV_COURSES
                  });
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardSection, {
              id: CARD_BUTTON_ID,
              onClick: function onClick() {
                return router.push({
                  pathname: constants/* ROUTES.CART */.Z6.CART
                });
              },
              children: [countOfProductsInCart > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(CardCount, {
                children: countOfProductsInCart
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardIcon, {
                name: Icon/* Icons.ShoppingCart */.PJ.ShoppingCart
              })]
            }), !isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsx)(LoginButton, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: handleLoginOrLogout,
                text: t('header.login'),
                size: Button/* ButtonSizes.SMALL */.P.SMALL
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchIcon, {
              onClick: function onClick() {
                setIsSearchOpen(true);
              },
              name: Icon/* Icons.Search */.PJ.Search
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuIcon, {
              onClick: function onClick() {
                toggleDisabledBackground();
                setIsMobileOpen(!isMobileOpen);
              },
              name: Icon/* Icons.Menu */.PJ.Menu
            }), isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsxs)(Notifications, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NotificationIcon, {
                name: Icon/* Icons.Notification */.PJ.Notification,
                onClick: function onClick() {
                  return setIsNotificationOpen(!isNotificationOpen);
                }
              }), (notifications === null || notifications === void 0 ? void 0 : notifications.length) > 0 && (notifications === null || notifications === void 0 ? void 0 : (_notifications$filter = notifications.filter(function (notification) {
                return !(notification !== null && notification !== void 0 && notification.read);
              })) === null || _notifications$filter === void 0 ? void 0 : _notifications$filter.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(NotificationUnread, {}), isNotificationOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationNotifications, {
                ref: mobileRef,
                children: [(notifications === null || notifications === void 0 ? void 0 : notifications.length) === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationEmptyMessage, {
                  dangerouslySetInnerHTML: {
                    __html: t('notifications.empty.label')
                  }
                }), (notifications === null || notifications === void 0 ? void 0 : notifications.length) > 0 && (notifications === null || notifications === void 0 ? void 0 : notifications.map(function (notification, key) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationNotification, {
                    onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
                      var _notification$url;

                      return regenerator_default().wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return calendar_service/* calendarApi.setMyNotificationRead */.w.setMyNotificationRead(notification === null || notification === void 0 ? void 0 : notification._key);

                            case 2:
                              if (!notification.url) {
                                _context4.next = 4;
                                break;
                              }

                              return _context4.abrupt("return", window.location.href = (_notification$url = notification.url) !== null && _notification$url !== void 0 && _notification$url.includes('https') ? notification.url : "".concat((0,constants/* getBaseUrl */.SV)()).concat(notification.url));

                            case 4:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    })),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationNotificationIcon, {
                      name: getNotificationIconByCategory(notification === null || notification === void 0 ? void 0 : notification.category)
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationNotificationCloseButton, {
                      onClick: function onClick(e) {
                        e.stopPropagation();
                        setNotifications(notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (filteredNotification) {
                          return (filteredNotification === null || filteredNotification === void 0 ? void 0 : filteredNotification._key) != (notification === null || notification === void 0 ? void 0 : notification._key);
                        }));
                        setNotificationsTotalCount(notificationsTotalCount - 1);
                        calendar_service/* calendarApi.deleteMyNotification */.w.deleteMyNotification(notification === null || notification === void 0 ? void 0 : notification._key);
                      },
                      children: "\u2715"
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationNotificationDetail, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationNotificationDetailTitle, {
                        children: notification === null || notification === void 0 ? void 0 : notification.title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationNotificationDetailDescription, {
                        dangerouslySetInnerHTML: {
                          __html: notification === null || notification === void 0 ? void 0 : notification.text
                        }
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationNotificationDetailDate, {
                        isPrimary: !(notification !== null && notification !== void 0 && notification.read),
                        children: [(0,time_utils/* formatNotificationDate */.q3)(notification === null || notification === void 0 ? void 0 : notification.created_at), !(notification !== null && notification !== void 0 && notification.read) && /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationNotificationDetailDateUnread, {})]
                      })]
                    })]
                  }, key);
                })), notificationsTotalCount > (notifications === null || notifications === void 0 ? void 0 : notifications.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationNotificationShowMoreLink, {
                  onClick: handlePreviousNotifications,
                  children: t('notifications.showMore.button')
                })]
              })]
            }), isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsxs)(Account, {
              ref: mobileRef,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AccountIcon, {
                onClick: function onClick() {
                  return setIsAccountOpen(true);
                },
                name: Icon/* Icons.User */.PJ.User
              }), isAccountOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationAccount, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationAccountHeader, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountCloseButton, {
                    onClick: function onClick() {
                      return setIsAccountOpen(false);
                    },
                    children: "\u2715"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationAccountLabel, {
                    children: [user === null || user === void 0 ? void 0 : user.name, " ", user === null || user === void 0 ? void 0 : user.surname]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountMail, {
                    children: user === null || user === void 0 ? void 0 : user.email
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLabel, {
                  children: t('header.myPV')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_PV_COURSES */.Z6.MY_PV_COURSES,
                  children: t('header.myCourses')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_PV_CONFERENCES */.Z6.MY_PV_CONFERENCES,
                  children: t('header.myConferences')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_PV_FAVOURITES */.Z6.MY_PV_FAVOURITES,
                  children: t('header.myFavourites')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_PV_MATERIALS */.Z6.MY_PV_MATERIALS,
                  children: t('header.myMaterials')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_PV_MYLOYALTY_PROGRAM */.Z6.MY_PV_MYLOYALTY_PROGRAM,
                  children: t('header.myLoyaltyProgram')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLabel, {
                  children: t('header.myAccount')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_ACCOUNT_USER */.Z6.MY_ACCOUNT_USER,
                  children: t('header.account')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_ACCOUNT_PASSWORD */.Z6.MY_ACCOUNT_PASSWORD,
                  children: t('header.password')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_ACCOUNT_NOTIFICATIONS */.Z6.MY_ACCOUNT_NOTIFICATIONS,
                  children: t('header.agreements')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.MY_ACCOUNT_ORDERS */.Z6.MY_ACCOUNT_ORDERS,
                  children: t('header.orders')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationAccountLink, {
                  onClick: function onClick() {
                    return setIsAccountOpen(false);
                  },
                  href: constants/* ROUTES.WITHDRAWAL */.Z6.WITHDRAWAL,
                  children: t('header.withdrawal')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                  marginTop: 40,
                  marginBottom: 20,
                  marginLeft: 25,
                  onClick: handleLoginOrLogout,
                  text: t('header.logout')
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Row, {
          $hideOnTablet: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationDesktop, {
            children: NAVIGATION_ITEMS_KEYS.map(function (item, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItem, {
                className: "".concat(router.pathname === item.path ? 'isActive' : ''),
                href: item.path,
                children: t(item.title)
              }, "desktop-".concat(key));
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Group, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactLink, {
              href: "mailto:".concat(t('header.mail')),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.Mail */.PJ.Mail
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactLinkLabel, {
                children: t('header.mail')
              })]
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationMobile, {
        ref: mobileRef,
        className: "".concat(isMobileOpen ? 'isOpen' : 'isClose'),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {
          onClick: function onClick() {
            return handleRedirect(constants/* ROUTES.HOME */.Z6.HOME);
          },
          src: (0,url_utils/* publicAssets */.VK)('/logo.webp')
        }), !isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          onClick: handleLoginOrLogout,
          text: t('header.login'),
          size: Button/* ButtonSizes.SMALL */.P.SMALL,
          marginTop: 35,
          marginBottom: 30
        }), NAVIGATION_ITEMS_KEYS.map(function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItemMobile, {
            onClick: function onClick() {
              handleMenuItem(item.path);
            },
            children: t(item.title)
          }, "mobile-".concat(key));
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationItem, {
          href: "tel:".concat(t('header.phone')),
          $marginTop: 35,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: Icon/* Icons.Phone */.PJ.Phone
          }), t('header.phone')]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationItem, {
          href: "mailto:".concat(t('header.mail')),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: Icon/* Icons.Mail */.PJ.Mail
          }), t('header.mail')]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationCloseButton, {
          onClick: function onClick() {
            toggleDisabledBackground();
            setIsMobileOpen(!isMobileOpen);
          },
          children: "x"
        })]
      })]
    })
  });
};

/* harmony default export */ var Header = (HeaderTemplate);

/***/ }),

/***/ 17923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ EventDateState; },
/* harmony export */   "CY": function() { return /* binding */ TrainingViewTypes; },
/* harmony export */   "GM": function() { return /* binding */ EventTypes; },
/* harmony export */   "RV": function() { return /* binding */ FilterViewTypes; },
/* harmony export */   "WD": function() { return /* binding */ EventStates; },
/* harmony export */   "f0": function() { return /* binding */ BannerTypes; },
/* harmony export */   "mN": function() { return /* binding */ NotificationCategory; }
/* harmony export */ });
;
var EventStates;

(function (EventStates) {
  EventStates[EventStates["NO_VISIBLE"] = 0] = "NO_VISIBLE";
  EventStates[EventStates["VISIBLE"] = 1] = "VISIBLE";
})(EventStates || (EventStates = {}));

var EventDateState;

(function (EventDateState) {
  EventDateState[EventDateState["AVAILABLE"] = 0] = "AVAILABLE";
  EventDateState[EventDateState["SOLD_OUT"] = 1] = "SOLD_OUT";
  EventDateState[EventDateState["CANCELLED"] = 2] = "CANCELLED";
})(EventDateState || (EventDateState = {}));

var EventTypes;

(function (EventTypes) {
  EventTypes["TRAINING"] = "0";
  EventTypes["CONFERENCE"] = "1";
  EventTypes["ARCHIVE"] = "2";
})(EventTypes || (EventTypes = {}));

var BannerTypes;

(function (BannerTypes) {
  BannerTypes["DESKTOP"] = "desktop";
  BannerTypes["TABLET"] = "tablet";
  BannerTypes["MOBILE"] = "mobile";
})(BannerTypes || (BannerTypes = {}));

var FilterViewTypes;

(function (FilterViewTypes) {
  FilterViewTypes["DESKTOP"] = "desktop";
  FilterViewTypes["MOBILE"] = "mobile";
})(FilterViewTypes || (FilterViewTypes = {}));

var TrainingViewTypes;

(function (TrainingViewTypes) {
  TrainingViewTypes["DESKTOP"] = "desktop";
  TrainingViewTypes["MOBILE"] = "mobile";
})(TrainingViewTypes || (TrainingViewTypes = {}));

var NotificationCategory;

(function (NotificationCategory) {
  NotificationCategory["notice"] = "notice";
  NotificationCategory["futureCourse"] = "futureCourse";
  NotificationCategory["recording"] = "recording";
  NotificationCategory["recommendation"] = "recommendation";
  NotificationCategory["futureCourseReminder"] = "futureCourseReminder";
  NotificationCategory["recordingReminder"] = "recordingReminder";
})(NotificationCategory || (NotificationCategory = {}));

/***/ }),

/***/ 81057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ FilterTypesInUrl; },
/* harmony export */   "N_": function() { return /* binding */ FilterTypesInResponse; },
/* harmony export */   "eD": function() { return /* binding */ MonthLabels; },
/* harmony export */   "fz": function() { return /* binding */ CourseTypes; },
/* harmony export */   "sP": function() { return /* binding */ ConferenceTypes; }
/* harmony export */ });
var FilterTypesInResponse;

(function (FilterTypesInResponse) {
  FilterTypesInResponse["TRAINING_TYPE"] = "CourseType";
  FilterTypesInResponse["CITY"] = "City";
  FilterTypesInResponse["CATEGORY"] = "Category";
  FilterTypesInResponse["MONTH"] = "Month";
  FilterTypesInResponse["LECTURER"] = "Person";
  FilterTypesInResponse["CONFERENCE_TYPE1"] = "ConferenceType1";
  FilterTypesInResponse["CONFERENCE_TYPE2"] = "ConferenceType2";
  FilterTypesInResponse["PACKAGES"] = "Packages";
})(FilterTypesInResponse || (FilterTypesInResponse = {}));

var FilterTypesInUrl;

(function (FilterTypesInUrl) {
  FilterTypesInUrl["TRAINING_TYPE"] = "skolenie_typ";
  FilterTypesInUrl["CITY"] = "mesto";
  FilterTypesInUrl["CATEGORY"] = "kategoria";
  FilterTypesInUrl["LECTURER"] = "lektor";
  FilterTypesInUrl["MONTH"] = "mesiac";
  FilterTypesInUrl["CONFERENCE_TYPE"] = "konferencia_typ";
  FilterTypesInUrl["ARCHIVED"] = "zrealizovane";
  FilterTypesInUrl["UPCOMING"] = "aktualne";
  FilterTypesInUrl["PAGE"] = "strana";
  FilterTypesInUrl["PACKAGES"] = "rocne_predplatne";
})(FilterTypesInUrl || (FilterTypesInUrl = {}));

var CourseTypes;

(function (CourseTypes) {
  CourseTypes["UPCOMING"] = "aktualne";
  CourseTypes["ONLINE"] = "online";
  CourseTypes["ATTENDANCE"] = "prezencne";
  CourseTypes["EXPERIENCE"] = "zazitkove";
  CourseTypes["ARCHIVED"] = "zaznamy";
})(CourseTypes || (CourseTypes = {}));

var MonthLabels = {
  1: 'január',
  2: 'február',
  3: 'marec',
  4: 'apríl',
  5: 'máj',
  6: 'jún',
  7: 'júl',
  8: 'august',
  9: 'september',
  10: 'október',
  11: 'november',
  12: 'december'
};
var ConferenceTypes;

(function (ConferenceTypes) {
  ConferenceTypes["ARCHIVED"] = "archived";
  ConferenceTypes["UPCOMING"] = "upcoming";
  ConferenceTypes[ConferenceTypes["DNATEACHER"] = 4] = "DNATEACHER";
  ConferenceTypes[ConferenceTypes["CS"] = 3] = "CS";
  ConferenceTypes[ConferenceTypes["DNA"] = 2] = "DNA";
  ConferenceTypes[ConferenceTypes["EPI"] = 1] = "EPI";
  ConferenceTypes[ConferenceTypes["PP"] = 0] = "PP";
})(ConferenceTypes || (ConferenceTypes = {}));

/***/ }),

/***/ 2253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ calendarApi; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40238);
/* harmony import */ var _interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81057);
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84107);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var GET_UPCOMING_EVENTS = 'pv/event/general/calendar/list';
var GET_ARCHIVE_VIDEOS = 'pv/event/video/latest/course';
var GET_MY_PV_FAVOURITE = 'pv/user/my-favorite';
var GET_MY_PV_COURSES = 'pv/user/my-courses';
var GET_MY_PV_CONFERENCES = 'pv/user/my-conferences';
var GET_MY_PV_VIDEOS = 'pv/user/my-videos';
var GET_MY_PV_NOTIFICATION = 'pv/notification/list';
var DELETE_MY_PV_NOTIFICATION = 'pv/notification';
var GET_MY_PV_MATERIALS = 'pv/user/my-materials';
var GET_ACADEMIES2 = 'pv/event/academy/list';
var GET_ACADEMIES = 'pv/module/list';
var GET_ACADEMY2 = 'pv/event/academy/slug';
var GET_ACADEMY = 'pv/module/slug';
var GET_GET_TRAININGS_FOR_ACADEMIES = 'pv/event/course/list/academie';
var GET_TRAININGS = 'pv/event/course/list';
var GET_TRAINING_BY_KEY = 'pv/event/course/key';
var GET_TRAINING = 'pv/event/course/slug';
var GET_CONFERENCES = 'pv/event/conference/list';
var GET_CONFRENCE = 'pv/event/conference';
var GET_CONFERENCE_BY_KEY = 'pv/event/conference/key';
var GET_HOMEPAGE_BANNERS = 'banner/homepage';
var GET_COURSES_BANNERS = 'banner/courses';
var GET_CONFERENCES_BANNERS = 'banner/conferences';
var ADD_COURSE_TO_FAVORITE = 'pv/user/favorite/course';
var DELETE_COURSE_FROM_FAVORITE = 'pv/user/favorite/course';
var ADD_CONFERENCE_TO_FAVORITE = 'pv/user/favorite/conference';
var UPDATE_WATCHED_TIME_TO_VIDEO = 'pv/event/video';
var DELETE_CONFERENCE_FROM_FAVORITE = 'pv/user/favorite/conference';
var SET_MY_NOTIFICATION_READ = 'pv/notification';
var SEARCH = 'search?page=0&size=5';
var GET_DATE = 'pv/event/date';
var GET_PERSON = 'pv/person';
var GET_GALLERY = 'pv/media/image/gallery';
var SEND_ORDER_FORM = 'pv/contact/order-form';
var SEND_BECOME_SPEAKER_FORM = 'pv/contact/become-speaker';
var STREAM_STATUS = 'pv/event/stream';
var SITEMAP = 'pv/sitemap';
var calendarApi = {
  getUpComingEvents: function getUpComingEvents(date, token, count, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_UPCOMING_EVENTS, {
      limit: count || 6,
      offset: offset || 0,
      date: date
    }, token);
  },
  getUpComingEventsTop: function getUpComingEventsTop(date, token, count, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_UPCOMING_EVENTS, {
      limit: count || 6,
      offset: offset || 0,
      date: date,
      top: true
    }, token);
  },
  getArchiveVideos: function getArchiveVideos(count) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_ARCHIVE_VIDEOS, {
      limit: count || 3,
      offset: 0
    });
  },
  getAcademies: function getAcademies(limit, offset, searchStr) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_ACADEMIES, _objectSpread(_objectSpread({}, searchStr && {
      query: searchStr
    }), {}, {
      limit: limit,
      offset: offset
    }));
  },
  getAcademies2: function getAcademies2(limit, offset, searchStr) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_ACADEMIES2, _objectSpread(_objectSpread({}, searchStr && {
      query: searchStr
    }), {}, {
      limit: limit,
      offset: offset
    }));
  },
  getAcademy: function getAcademy(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_ACADEMY, "/").concat(slug), {}, token);
  },
  getAcademy2: function getAcademy2(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_ACADEMY2, "/").concat(slug), {}, token);
  },
  getStreamStatus: function getStreamStatus(streamId) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(STREAM_STATUS, "/").concat(streamId, "/info"));
  },
  getMyNotifications: function getMyNotifications(limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_MY_PV_NOTIFICATION, {
      limit: limit
    });
  },
  deleteMyNotification: function deleteMyNotification(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["delete"] */ .Z["delete"]("".concat(DELETE_MY_PV_NOTIFICATION, "/").concat(key));
  },
  getMyFavourite: function getMyFavourite(limit, offset, search) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_MY_PV_FAVOURITE, {
      limit: limit || 10,
      offset: offset || 0,
      query: search
    });
  },
  getMyConferences: function getMyConferences(limit, offset, search, city, lecturer, type, archived, upcoming) {
    var _ref, _ref$split, _ref$split$filter;

    var filteredType = (_ref = type ? String(type) : '') === null || _ref === void 0 ? void 0 : (_ref$split = _ref.split(',')) === null || _ref$split === void 0 ? void 0 : (_ref$split$filter = _ref$split.filter(function (type) {
      return ![_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .ConferenceTypes.ARCHIVED */ .sP.ARCHIVED, _interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .ConferenceTypes.UPCOMING */ .sP.UPCOMING].includes(type);
    })) === null || _ref$split$filter === void 0 ? void 0 : _ref$split$filter.join(',');
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_MY_PV_CONFERENCES, _objectSpread(_objectSpread({
      limit: limit || 10,
      offset: offset || 0,
      query: search,
      venues: city,
      people: lecturer
    }, filteredType && {
      type: filteredType
    }), {}, {
      upcoming: !archived || upcoming,
      archived: archived
    }));
  },
  getMyMaterials: function getMyMaterials(limit, offset, search) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_MY_PV_MATERIALS, {
      limit: limit || 10,
      offset: offset || 0,
      query: search
    });
  },
  getMyCourses: function getMyCourses(limit, offset, search, city, lecturer, category, type, month) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_MY_PV_COURSES, {
      limit: limit || 10,
      offset: offset || 0,
      query: search,
      venues: city,
      people: lecturer,
      categories: category,
      months: month,
      upcoming: !(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ARCHIVED */ .fz.ARCHIVED)),
      online: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ONLINE */ .fz.ONLINE)),
      attendance: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ATTENDANCE */ .fz.ATTENDANCE)),
      experience: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.EXPERIENCE */ .fz.EXPERIENCE)),
      archived: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ARCHIVED */ .fz.ARCHIVED))
    });
  },
  getMyCoursesForGuest: function getMyCoursesForGuest(token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_MY_PV_COURSES, {}, token);
  },
  getMyConferencesForGuest: function getMyConferencesForGuest(token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_MY_PV_CONFERENCES, {}, token);
  },
  getTrainings: function getTrainings(limit, offset, search, city, lecturer, category, type, month, packages, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_TRAININGS, {
      limit: limit || _constants__WEBPACK_IMPORTED_MODULE_1__/* .TRAININGS_LIMIT_PER_PAGE */ .jp,
      offset: offset || 0,
      query: search,
      venues: city,
      people: lecturer,
      categories: category,
      months: month,
      packages: packages,
      upcoming: !(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ARCHIVED */ .fz.ARCHIVED)),
      online: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ONLINE */ .fz.ONLINE)),
      attendance: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ATTENDANCE */ .fz.ATTENDANCE)),
      experience: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.EXPERIENCE */ .fz.EXPERIENCE)),
      archived: !!(type !== null && type !== void 0 && type.includes(_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .CourseTypes.ARCHIVED */ .fz.ARCHIVED))
    }, token);
  },
  getTrainingsForAcademies: function getTrainingsForAcademies(limit, offset, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_GET_TRAININGS_FOR_ACADEMIES, {
      upcoming: true
    }, token);
  },
  setMyNotificationRead: function setMyNotificationRead(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("".concat(SET_MY_NOTIFICATION_READ, "/").concat(key, "/read"), {});
  },
  getTraining: function getTraining(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_TRAINING, "/").concat(slug), {}, token);
  },
  getTrainingByKey: function getTrainingByKey(key, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_TRAINING_BY_KEY, "/").concat(key), {}, token);
  },
  getTrainingDates: function getTrainingDates(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_TRAINING, "/").concat(slug, "/date/list"), {}, token);
  },
  getTrainingLecturers: function getTrainingLecturers(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_TRAINING, "/").concat(slug, "/person/list"), {}, token);
  },
  getTrainingModules: function getTrainingModules(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_TRAINING, "/").concat(slug, "/module/list"), {}, token);
  },
  getHomepageBanners: function getHomepageBanners() {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_HOMEPAGE_BANNERS);
  },
  getCoursesBanners: function getCoursesBanners() {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_COURSES_BANNERS);
  },
  getConferencesBanner: function getConferencesBanner() {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_CONFERENCES_BANNERS);
  },
  addCourseToFavourite: function addCourseToFavourite(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].put */ .Z.put(ADD_COURSE_TO_FAVORITE, {
      _key: key
    });
  },
  deleteCourseFromFavourite: function deleteCourseFromFavourite(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["delete"] */ .Z["delete"]("".concat(DELETE_COURSE_FROM_FAVORITE, "/").concat(key));
  },
  addConferenceToFavourite: function addConferenceToFavourite(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].put */ .Z.put(ADD_CONFERENCE_TO_FAVORITE, {
      _key: key
    });
  },
  deleteConferenceFromFavourite: function deleteConferenceFromFavourite(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"]["delete"] */ .Z["delete"]("".concat(DELETE_CONFERENCE_FROM_FAVORITE, "/").concat(key));
  },
  updateWatchedTimeToVideo: function updateWatchedTimeToVideo(key, time) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].put */ .Z.put("".concat(UPDATE_WATCHED_TIME_TO_VIDEO, "/").concat(key, "/watchtime"), {
      timeWatched: time
    });
  },
  saveWatchedSecondsToVideo: function saveWatchedSecondsToVideo(key, data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].put */ .Z.put("".concat(UPDATE_WATCHED_TIME_TO_VIDEO, "/").concat(key, "/stats"), data);
  },
  getConferences: function getConferences(limit, offset, search, city, lecturer, type, archived, upcoming, token) {
    var _type$split, _type$split$filter;

    var filteredType = type === null || type === void 0 ? void 0 : (_type$split = type.split(',')) === null || _type$split === void 0 ? void 0 : (_type$split$filter = _type$split.filter(function (type) {
      return ![_interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .ConferenceTypes.ARCHIVED */ .sP.ARCHIVED, _interfaces_Filter__WEBPACK_IMPORTED_MODULE_2__/* .ConferenceTypes.UPCOMING */ .sP.UPCOMING].includes(type);
    })) === null || _type$split$filter === void 0 ? void 0 : _type$split$filter.join(',');
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(GET_CONFERENCES, _objectSpread(_objectSpread({
      limit: limit || 10,
      offset: offset || 0,
      query: search,
      venues: city,
      people: lecturer
    }, filteredType && {
      type: filteredType
    }), {}, {
      upcoming: !archived || upcoming,
      archived: archived
    }), token);
  },
  search: function search(searchPhrase, filters) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post(SEARCH, filters, {}, {
      searchPhrase: searchPhrase
    });
  },
  getConferenceKey: function getConferenceKey(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_CONFRENCE, "/").concat(key), {});
  },
  getConferenceSlug: function getConferenceSlug(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_CONFRENCE, "/slug/").concat(slug), {}, token);
  },
  getConferenceKeyAndToken: function getConferenceKeyAndToken(key, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_CONFERENCE_BY_KEY, "/").concat(key), {}, token);
  },
  getConferenceDates: function getConferenceDates(slug, token) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_CONFRENCE, "/slug/").concat(slug, "/date/list"), {}, token);
  },
  getDateData: function getDateData(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_DATE, "/").concat(key), {});
  },
  getPersonData: function getPersonData(key) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_PERSON, "/").concat(key), {});
  },
  getSitemapSlugs: function getSitemapSlugs() {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(SITEMAP, {});
  },
  getGalleryImages: function getGalleryImages(key, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("".concat(GET_GALLERY, "/").concat(key, "/image/list"), {
      limit: limit || 100,
      offset: offset || 0
    });
  },
  sendOrderForm: function sendOrderForm(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("".concat(SEND_ORDER_FORM), data);
  },
  sendBecomeSpeakerForm: function sendBecomeSpeakerForm(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("".concat(SEND_BECOME_SPEAKER_FORM), data);
  }
};

/***/ }),

/***/ 74920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Content; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Content/Content.element.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Contentelement__Wrapper",
  componentId: "sc-1rggtrg-0"
})(["max-width:", "px;margin:0 auto;padding-top:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";@media (min-width:", "px){padding-left:", ";padding-right:", ";}"], (0,constants/* getMaxPageWidth */.Fd)(), function (props) {
  return props.$withPadding ? (0,polished_esm/* rem */.hO)(40) : 0;
}, function (props) {
  return props.$withPadding ? (0,polished_esm/* rem */.hO)(40) : 0;
}, function (props) {
  return props.$mobileSidePadding || props.$sidePadding ? (0,polished_esm/* rem */.hO)(props.$mobileSidePadding || props.$sidePadding) : 0;
}, function (props) {
  return props.$mobileSidePadding || props.$sidePadding ? (0,polished_esm/* rem */.hO)(props.$mobileSidePadding || props.$sidePadding) : 0;
}, theme/* breakpoints.md */.A.md, function (props) {
  return props.$sidePadding ? (0,polished_esm/* rem */.hO)(props.$sidePadding) : 0;
}, function (props) {
  return props.$sidePadding ? (0,polished_esm/* rem */.hO)(props.$sidePadding) : 0;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Content/Content.tsx




var ContentTemplate = function ContentTemplate(_ref) {
  var children = _ref.children,
      _ref$withPadding = _ref.withPadding,
      withPadding = _ref$withPadding === void 0 ? false : _ref$withPadding,
      sidePadding = _ref.sidePadding,
      mobileSidePadding = _ref.mobileSidePadding,
      id = _ref.id;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    $withPadding: withPadding,
    $sidePadding: sidePadding,
    $mobileSidePadding: mobileSidePadding,
    id: id,
    children: children
  });
};

/* harmony default export */ var Content = (ContentTemplate);

/***/ }),

/***/ 775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b$": function() { return /* binding */ closestDateFrom; },
/* harmony export */   "ki": function() { return /* binding */ secondsToHMS; },
/* harmony export */   "lT": function() { return /* binding */ parseHourAndMinutes; },
/* harmony export */   "q3": function() { return /* binding */ formatNotificationDate; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var secondsToHMS = function secondsToHMS(secs) {
  var sec_num = parseInt(String(secs), 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor(sec_num / 60) % 60;
  var seconds = sec_num % 60;
  return [hours, minutes, seconds].map(function (v) {
    return v < 10 ? '0' + v : v;
  }).filter(function (v, i) {
    return v !== '00' || i > 0;
  }).join(':');
};
var parseHourAndMinutes = function parseHourAndMinutes(secs) {
  var hours = Math.floor(secs / 3600);
  var minutes = Math.floor((secs - hours * 3600) / 60);
  var minutesStr = String(Math.floor((secs - hours * 3600) / 60));
  var res = '';

  if (hours > 0) {
    res += "".concat(hours, "h ");
  }

  if (minutes > 0) {
    res += "".concat(minutesStr, " min.");
  } else {
    res += "0 min.";
  }

  return res;
};
var closestDateFrom = function closestDateFrom(eventDates) {
  return eventDates.find(function (eventDate) {
    var diff = moment__WEBPACK_IMPORTED_MODULE_0___default()(eventDate.date.from).diff(moment__WEBPACK_IMPORTED_MODULE_0___default()(), 'minutes');
    return diff >= 0;
  });
};
var formatNotificationDate = function formatNotificationDate(date) {
  var dayDiffNumber = moment__WEBPACK_IMPORTED_MODULE_0___default()(date).startOf('day').diff(moment__WEBPACK_IMPORTED_MODULE_0___default()().startOf('day'), 'days', true);
  if (dayDiffNumber === 0) return 'dnes';
  if (dayDiffNumber === -1) return 'včera';
  if (dayDiffNumber < -1 && dayDiffNumber > -7) return "pred ".concat(Math.abs(Math.floor(dayDiffNumber)), " d\u0148ami");
  if (dayDiffNumber <= -7 && dayDiffNumber > -14) return 'pred týždňom';
  if (dayDiffNumber <= -14) return "pred ".concat(Math.abs(Math.floor(dayDiffNumber / 7)), " t\xFD\u017Ed\u0148ami");
};

/***/ })

}]);